function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
const SvgHighlighter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  className: props.className || ''
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3.684 9.58a2.64 2.64 0 0 1 .733 2.857l1.635.674m2.535-1.496a2.623 2.623 0 0 0-2.54 1.5M5.12 13l-.32.887m3.95.446h5.67m-5.166-3.72L3.921 8.4l3.308-6.507a1.185 1.185 0 0 1 1.546-.4l1.92.796c.58.18.934.78.807 1.38l-2.248 6.944Z"
}));
export default SvgHighlighter;